var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 24,
    height: 24,
    transform: "translate(-23931 -12607)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(-1731.703 -1863.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_35",
    "data-name": "Mask Group 35",
    transform: "translate(25662.703 14470.999)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M-798.3-2985.648l4.962-4.962,4.963,4.962-4.963,4.963Zm2.274,0,2.688,2.689,2.689-2.689-2.689-2.689Zm4.421-6.695,4.963-4.963,4.962,4.963-4.962,4.963Zm2.274,0,2.689,2.689,2.689-2.689-2.689-2.69Zm-15.663,0,4.962-4.963,4.963,4.963-4.963,4.963Zm2.273,0,2.689,2.689,2.689-2.689-2.689-2.69Zm4.422-6.695,4.962-4.963,4.963,4.963-4.963,4.963Zm2.274,0,2.688,2.689,2.689-2.689-2.689-2.689Z",
    transform: "translate(-21241.977 -11040.086) rotate(-45)",
    fill: "#918f90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmissions);
export default __webpack_public_path__ + "static/media/submissions.f9efe123dc900812a0267edf4fcbcb0b.svg";
export { ForwardRef as ReactComponent };